// Butterfly Currency Configuration - MiniCaryn
// Controls the virtual currency system for one-time purchases.
// Internal names (MoonPackId, MOON_PACKS, etc.) are kept for code compatibility.
// Only user-facing CURRENCY_* values are changed to Butterflies.
export const WALLET_ONLY_MODE = false

// Moon pack definitions — matches backend/config/moonConfig.js exactly
// 1 Moon = $0.01 (1 cent) — flat rate, no bonuses
export const MOON_PACKS = [
  { id: 'pack_10',  moons: 1000,  priceCents: 1000,  display: '$10'  },
  { id: 'pack_25',  moons: 2500,  priceCents: 2500,  display: '$25'  },
  { id: 'pack_50',  moons: 5000,  priceCents: 5000,  display: '$50'  },
  { id: 'pack_100', moons: 10000, priceCents: 10000, display: '$100' },
  { id: 'pack_250', moons: 25000, priceCents: 25000, display: '$250' },
  { id: 'pack_500', moons: 50000, priceCents: 50000, display: '$500' },
] as const

export type MoonPackId = typeof MOON_PACKS[number]['id']

// Convert USD dollars to Moons (1 Moon = $0.01)
export function dollarToMoons(dollars: number): number {
  return Math.round(dollars * 100)
}

export const MOON_TIP_PRESETS = [5, 10, 25, 50, 100] as const

// Currency display (user-facing labels) — pure USD, no coin symbol
export const CURRENCY_NAME = 'USD'
export const CURRENCY_SYMBOL = '' // pure USD, no coin symbol
export const CURRENCY_NAME_SINGULAR = 'USD'

// Wallet balances and prices are now real USD dollar amounts (CC-style).
export function formatMoons(amount: number): string {
  return `$${(amount ?? 0).toFixed(2)}`
}

export function formatMoonsLong(amount: number): string {
  return `$${(amount ?? 0).toFixed(2)} USD`
}

// === PER-MESSAGE MOON COST ===
// When enabled, each fan message costs MESSAGE_MOON_COST moons
// Set MESSAGE_MOON_COST_ENABLED to false to completely disable this feature
export const MESSAGE_MOON_COST_ENABLED = false // CC-style: messaging is free
export const MESSAGE_MOON_COST = 100  // moons per message ($1.00)
